module.exports = __webpack_public_path__ + "assets/img/xiaoxi2.aea4aa67.png";